module.exports = __webpack_public_path__ + "img/coloredeer.f02f5a98.jpg";